import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ISearchSubtitlesForChallengeV1Request } from './search-subtitles-for-challenge-v1-request';
import type { ISearchSubtitlesForChallengeV1Response } from './search-subtitles-for-challenge-v1-response';
import { searchSubtitlesForChallengeV1ResponseSchema } from './search-subtitles-for-challenge-v1-response';

export async function searchSubtitlesForChallengeV1Api({
  challengeId,
}: ISearchSubtitlesForChallengeV1Request): Promise<
  IValidatedResponse<ISearchSubtitlesForChallengeV1Response>
> {
  return getRequest<ISearchSubtitlesForChallengeV1Response>({
    path: `/sys/challenges/v1/${challengeId}/subtitle-search`,
    schema: searchSubtitlesForChallengeV1ResponseSchema,
  });
}
